module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_250_500.ab700ed6.png";